import { Box, Stack, Typography } from "@mui/material";
import * as React from "react";
import FaqQuestion from "../components/buildingBlocks/FaqQuestion";
import { questions } from "../data/questions";
import { T } from "../components/T";

export const Faq: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",

          padding: "2rem 0",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            mb: 2,
            color: "primary.contrastText",
          }}
        >
          <T str="Frequently Asked Questions" />
        </Typography>

        <Stack
          spacing={0}
          sx={{
            width: { xs: "90%", sm: "80%", md: "60%", lg: "50%" },
          }}
        >
          {questions.map((question, index) => (
            <FaqQuestion
              key={index}
              question={question.question}
              answer={question.answer}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default Faq;
